import React, { useMemo, useState } from 'react'
import {
  EyeInvisibleOutlined,
  EyeOutlined,
  LoadingOutlined
} from '@ant-design/icons'
import openNotification from './Notification/openNotification '
import { showRecruitmentPhone } from '../../services/management-recruitment-service'
import { showCustomerDataPhone } from '../../services/data-customer-service'
import { showPostPhone } from '../../services/postservice'
import { showRequestPhone } from '../../services/requestservice'

const ADMIN_EMAIL = 'admin.g18@gmail.com'

export default function PhoneVisibilityCell({
  value,
  customerDataId,
  postId,
  recruitmentId,
  requestId,
  type = 'post',
  from = 1
}) {
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [displayValue, setDisplayValue] = useState(value)
  const currentEmail = useMemo(
    () => (localStorage.getItem('user_email') || '').toLowerCase(),
    []
  )

  const handleToggleVisible = async () => {
    if (visible) {
      setVisible(false)
      return
    }

    const targetId =
      type === 'request'
        ? requestId
        : type === 'customerData'
          ? customerDataId
          : type === 'recruitment'
            ? recruitmentId
            : postId

    if (!targetId) {
      setVisible(true)
      return
    }

    setLoading(true)
    try {
      const response =
        type === 'request'
          ? await showRequestPhone(targetId)
          : type === 'customerData'
            ? await showCustomerDataPhone(targetId)
            : type === 'recruitment'
              ? await showRecruitmentPhone(targetId)
              : await showPostPhone(targetId, from)
      setDisplayValue(response?.data || value)
      setVisible(true)
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }

  if (currentEmail === ADMIN_EMAIL) {
    return <span>{displayValue || value || '-'}</span>
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      {visible && <span>{displayValue || value || '-'}</span>}

      <span
        onClick={loading ? undefined : handleToggleVisible}
        style={{
          cursor: loading ? 'not-allowed' : 'pointer',
          color: '#1677ff',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4
        }}
      >
        {loading ? (
          <LoadingOutlined />
        ) : visible ? (
          <EyeInvisibleOutlined />
        ) : (
          <EyeOutlined />
        )}
        <span>{visible ? '' : 'Xem'}</span>
      </span>
    </span>
  )
}
